import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"

export const UnitDetailMfGrid_s = styled.div`
  width: 375px;

  .p-paginator {
    position: relative;
    width: 375px;
  }

  ${DataTable_s}{
    overflow-y: visible !important;
  }
`

export const MarketLeaseGrid_s = styled.div`
  width: 375px;

  .p-paginator {
    position: relative;
    width: 475px;
  }

  ${DataTable_s}{
    overflow-y: visible !important;

    .p-datatable-thead div.p-checkbox { margin-left: -8px; }
  }
`

export const TenantGrid_s = styled.div`
  width: 525px;

  .p-paginator {
    position: relative;
    width: 525px;
  }

  ${DataTable_s}{
    overflow-y: visible !important;

    .p-datatable-thead div.p-checkbox { margin-left: -8px; }
  }
`

export const CashFlowReport_s = styled.div`
  .line-item-detail-input {
    width: 180px;
  }
  .start-year-input {
    width: 180px;
  }
`

export const ComparisonReport_s = styled.div`
  .comparison-input { 
    width: 220px !important; 
  }
`